import { ApiUser, User } from '../model';
import { httpClient, postProcessUpsert } from '@genai/http-client';

let userCache: User;

export const loadUser = async () => {
  if (!userCache) {
    userCache = await httpClient(`/users/me`, {
      method: "GET"
    })
      .then(postProcessUpsert<ApiUser>)
      .then((user) => user as User);
  }

  return userCache;
};
